module.exports = __webpack_public_path__ + "static/media/hartwall-checkmark-outline.343064d6.svg";